<div *ngIf="plan">
  <span *ngFor="let plans of plan.connectivityPlans; last as isLast">
    <!-- TODO: Migrate MyPlans to Microapp -->
    <!-- <ng-container *ngIf="canOpenPlanModal">
      <a class="gb-body1 heavy" (click)="openPlanInfoModal(plan)">{{ plans.planId }}</a>
      <span *ngIf="!isLast" class="gb-body1 heavy"> & </span>
    </ng-container> -->
    <span *ngIf="!canOpenPlanModal" class="gb-body1 heavy">{{plans.planId}} {{isLast? ' ' : ' & ' }}</span>
  </span>
  {{includedPlanAndDate}}
</div>
